import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFetchSeeAllDataQuery } from "../../api/homepageApi";
import Loading from "../../components/loading";
import { IoChevronBack } from "react-icons/io5";

// see all components
import MusicSeeall from "../../components/musicSeeall/MusicSeeall";
import ArtistSeeAll from "../../components/artistSeeAll/ArtistSeeAll";
import AlbumSeeAll from "../../components/albumSeeAll/AlbumSeeAll";
import PlayListSeeAll from "../../components/playlistSeeAll/PlayListSeeAll";

// custom context
import { useNavbar } from "../../context/NavBarContext";

// Loading Screen
import MusicSongLoading from "../../components/skeletonLoading/musicSongLoading/MusicSongLoading";
import MusicArtistListLoading from "../../components/skeletonLoading/musicArtistListLoading/MusicArtistListLoading";
import MusicAlbumSeeAllLoading from "../../components/skeletonLoading/musicAlbumListLoading/MusicAlbumListLoading";
import AudioPlayListSeeAllLoading from "../../components/skeletonLoading/audioPlaylistLoading/AudioPlaylistLoading";

import { NotFound } from "../error/NotFound_404";

const Index = () => {
  const Navbar = useNavbar();

  const category_id = useParams().category_id;
  const category_type = useParams().category_type;
  const [render, setRender] = useState();
  const options = {
    url: "/music/seeall",
    category_id: category_id,
  };
  // fetch seeall api
  const { data, isLoading, error } = useFetchSeeAllDataQuery(options);

  useEffect(() => {
    if (data) {
      switch (category_type) {
        case "songs":
          Navbar.setLogoPlace(data.title);
          setRender(<MusicSeeall data={data.result} />);
          break;
        case "artist":
          Navbar.setLogoPlace("အဆိုတော်များ");
          setRender(<ArtistSeeAll data={data.result} />);
          break;
        case "album":
          Navbar.setLogoPlace(data.title);
          setRender(<AlbumSeeAll data={data.result} />);
          break;
        case "playlist":
          Navbar.setLogoPlace("SNS's Playlist");
          setRender(<PlayListSeeAll data={data.result} />);

          break;
        default:
          break;
      }
      Navbar.setToPrevPage(1);

      Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
    }
  }, [data, isLoading]);

  if (isLoading) {
    switch (category_type) {
      case "songs":
        return <MusicSongLoading />;
        break;
      case "artist":
        // setRender(<ArtistSeeAll data={data.result} />);
        return <MusicArtistListLoading />;
        break;
      case "album":
        return <MusicAlbumSeeAllLoading />;
        break;
      case "playlist":
        return <AudioPlayListSeeAllLoading />;
        break;
      default:
        break;
    }
  }

  if (error) {
    return <NotFound error={error} />;
  }

  return <div>{render}</div>;
};

export default Index;
